<attribute-reason-modal>
    <dialog id="attribute-reason-modal" class="modal" aria-labelledby="attribute-reason-modal-heading">
        <div class="modal-box">
            <form method="dialog">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}"
                        onclick="{handleCancel}">
                    <i class="icon-clear" aria-hidden="true"></i>
                </button>
            </form>
            <h3 id="attribute-reason-modal-heading" class="font-bold text-lg">{locale?.t('attributereasonmodal_reasonfor') + ' '}<span class="capitalize">{state.attributeKey}</span>{' ' + locale?.t('attributereasonmodal_update')}</h3>
            <p class="py-2">
                {locale?.t('attributereasonmodal_youare') + ' '}
                <span if="{state.count != null}">{locale?.t('attributereasonmodal_updating') + ' '}<span class="capitalize inline-block">{state.attributeKey}</span>{' ' + locale?.t('attributereasonmodal_oncount', { count: state.count })}</span>
                <span if="{state.count == null && (!state.attributeValue && state.attributeValue !== 0)}">{locale?.t('attributereasonmodal_clearing') + ' '}<span class="capitalize inline-block">{state.attributeKey}</span></span>
                <span if="{state.count == null && (state.attributeValue || state.attributeValue === 0)}">{locale?.t('attributereasonmodal_updating') + ' '}<span class="capitalize inline-block">{state.attributeKey}</span>{' ' + locale?.t('to') + ' '}"{state.attributeValue}"</span>.<br>
                {locale?.t('attributereasonmodal_providereason')}
            </p>
            <div class="form-control w-full py-2">
                <textarea
                    id="attribute-reason-modal-reason"
                    class="textarea textarea-bordered h-24 w-full"
                    placeholder="{locale?.t('attributereasonmodal_placeholder')}"
                    aria-label="{locale?.t('attributereasonmodal_placeholder')}"
                    value="{state.reason}"
                    oninput="{handleInput}"
                    ref="reasonInput"
                ></textarea>
            </div>
            <div class="modal-action">
                <button class="btn text-primary rounded-lg" onclick="{handleCancel}">{locale?.t('cancel')}</button>
                <button class="btn btn-primary" onclick="{handleConfirm}" disabled="{!state.reason || !state.reason.trim()}">{locale?.t('submit')}</button>
            </div>
        </div>
        <form method="dialog" class="modal-backdrop">
            <button onclick="{handleCancel}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        export default {
            state: {
                attributeKey: 'attribute',
                attributeValue: '',
                count: null,
                reason: '',
                onComplete: null
            },

            show(attributeKey = 'attribute', attributeValue = '', count = null) {
                return new Promise((resolve) => {
                    this.update({
                        attributeKey,
                        attributeValue,
                        count,
                        reason: '',
                        onComplete: resolve
                    })
                    document.getElementById('attribute-reason-modal').showModal()

                    // Focus the textarea after a short delay to ensure modal is rendered
                    setTimeout(() => {
                        this.$('textarea')?.focus()
                    }, 100)
                })
            },

            handleInput(e) {
                this.state.reason = e.target.value;
                this.update();
            },

            handleConfirm() {
                const reason = this.state.reason.trim()
                if (this.state.onComplete) {
                    this.state.onComplete(reason || null)
                }
                this.state.reason = ''
                document.getElementById('attribute-reason-modal').close()
            },

            handleCancel() {
                if (this.state.onComplete) {
                    this.state.onComplete(null)
                }
                this.state.reason = ''
                document.getElementById('attribute-reason-modal').close()
            },

            onMounted() {
                // Make globally accessible
                window.attributeReasonModal = this
            }
        }
    </script>
</attribute-reason-modal>
